import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AppService } from '../../services/app.service';
import { UserState } from '../../store/user.state';
import { IonHeader } from '@ionic/angular/standalone';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderDesktopComponent } from './header-desktop/header-desktop.component';
import { HeaderMobileComponent } from './header-mobile/header-mobile.component';
import { ProductTourBackgroundComponent } from '../product-tour/product-tour-background/product-tour-background.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [IonHeader, AsyncPipe, TranslateModule, HeaderDesktopComponent, HeaderMobileComponent, ProductTourBackgroundComponent],
})
export class HeaderComponent {
  @Input() hide = false;
  @Input() customTitle?: string;
  @Input() showAvatar: boolean = true;
  @Input() showBackButton: boolean = true;
  @Output() navigateBack = new EventEmitter<void>();

  constructor(
    public userState: UserState,
    public appService: AppService,
  ) {}

  onNavigateBack(): void {
    this.navigateBack.emit();
  }
}
